import React from "react";
import { Outlet } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { InteractivesLayout } from "./InteractivesLayout";

import { useContentVisit } from "../stats/useContentVisit";
import { interactiveDefinitions } from "./interactiveDefinitions";

export default function InteractiveSite() {
  useContentVisit("interactives", interactiveDefinitions);
  useTitle("Interactives");
  return (
    <InteractivesLayout>
      <Outlet />
    </InteractivesLayout>
  );
}
